import InformationPage from "../../components/InformationPage"
import { getServerErrorData } from "../../utils/errors"
import { AuthData, AuthResponse } from "../../api/auth/actions"

const defaultmsg: AuthData = {
    Code: "",
    Msg: {
        companies: [],
        code: "",
        app: "",
        applink: undefined
    }
}

const ServerError = ({
    data = defaultmsg,
    redir = "",
}) => {
    const authres = data.Msg as AuthResponse
    const { title, message } = getServerErrorData(data.Code, { app: authres?.app })

    return (<InformationPage
        title={title}
        subtitle={message}
        buttonLabel={redir !== "" ? "Continue" : ""}
        buttonLink={redir} />)
}

export default ServerError